import { generatePath } from 'react-router-dom';

export function getUrlUtils(route: string) {
  // returns url from params, or an empty string if params does not match route
  function getUrl(params?: Record<string, any>): string {
    try {
      return generatePath(route, params || {});
    } catch (e) {
      console.error(e.message);
      return '';
    }
  }
  return { getUrl };
}
